import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

class LogoSlider {
	constructor(el) {
		this.root = el;
		this.initSlider();
	}

	initSlider() {
		this.imageAndCopySlider = new Swiper(this.root.querySelector('.js-logoSliderContainer'), {
			spaceBetween: 25,
			slidesPerView: 2,
			grabCursor: true,
			loop: true,
			slideActiveClass: 'is-active',

			navigation: {
				nextEl: this.root.querySelector('.js-logoSliderArrowNext'),
				prevEl: this.root.querySelector('.js-logoSliderArrowPrev'),
				disabledClass: 'is-disabled',
			},

			breakpoints: {
				768: {
					spaceBetween: 18,
					slidesPerView: 3,
				},
				1256: {
					spaceBetween: 40,
					slidesPerView: 4,
				},
			},
		});
	}
}

Array.from(document.querySelectorAll('.js-logoSlider')).forEach(el => new LogoSlider(el));
